<template>
  <div class="app flex-row align-items-center login-page">
    <div class="container">
      <!-- <v-icon class="card-image">$Pet</v-icon> -->
      <v-row class="justify-content-center">
        <v-col md="8" cols="12">
          <transition name="fade" mode="out-in">
            <v-card class="login-card">
              <div class="d-flex flex-column justify-center">
                <div class="logo-login">
                  <img src="../assets/images/logoname.png" />
                </div>
                <h4 class="text-center mb-15 fs-medium font-weight-bold mt-5">
                  به سامانه کتاب باز خوش آمدید
                </h4>

                <v-row>
                  <v-col class="text-center">
                    <div>
                      <v-text-field
                        append-icon="mdi-account"
                        placeholder="نام کاربری"
                        outlined
                        v-model="username"
                      ></v-text-field>
                      <v-text-field
                        append-icon="mdi-lock"
                        outlined
                        :prepend-inner-icon="
                          showPass ? 'mdi-eye' : 'mdi-eye-off'
                        "
                        :type="showPass ? 'text' : 'password'"
                        @click:prepend-inner="showPass = !showPass"
                        placeholder="رمز عبور"
                        v-model="password"
                        @keyup.enter="password && username ? login() : ''"
                      ></v-text-field>
                      <v-row>
                        <v-col>
                          <v-btn
                            :loading="busy"
                            @click="login()"
                            :disabled="busy || !(password && username)"
                            height="40"
                            block
                            class="purple2-mainBtn"
                            >ورود
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </transition>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import md5 from "js-md5";

export default {
  data() {
    return {
      username: "",
      password: "",
      mobile: "",
      role: "",
      busy: false,
      showPass: false,
    };
  },
  methods: {
    login() {
      this.busy = true;
      Axios.post(this.baseUrl + "/satrapp/auth/login", {
        username: this.username,
        password: md5(this.password),
      })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            localStorage.clear();
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("role", res.data.role);
            localStorage.setItem("name", res.data.name);
            localStorage.setItem("userId", res.data.id);
            // if (this.$route.query.return)
            //   this.$router.push(this.$route.query.return);
            // else this.$router.push("/" + res.data.role + "/dashboard");
            if (res.data.role != "sales") {
              this.$router.push("/" + res.data.role + "/dashboard");
            } else {
              this.$router.push("/sales/newInvoice");
            }
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      localStorage.role == "sales"
        ? this.$router.push("/sales/newinvoice")
        : localStorage.role == "shop" || localStorage.role == "Manager"
        ? this.$router.push("/" + localStorage.role + "/dashboard")
        : "";
    }
  },
};
</script>
<style lang="scss">
.app {
  background-color: #f0f3ff;
}
.logo-login {
  display: flex;
  align-self: center;
  width: 130px;
  height: auto;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.login-page {
  background: rgb(160, 118, 249);
  background: linear-gradient(
    16deg,
    rgba(160, 118, 249, 1) 0%,
    rgba(179, 145, 251, 1) 23%,
    rgba(196, 170, 252, 1) 44%,
    rgba(211, 191, 253, 1) 61%,
    rgba(223, 209, 254, 1) 84%,
    rgba(237, 228, 255, 1) 100%
  );
  .container {
    width: 70%;
  }
  @media only screen and (max-width: 600px) {
    .container {
      width: 90%;
      padding: 0;
    }
  }

  .login-card {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-52%, -50%);
    width: 45vw;
    margin: auto;
    border-radius: 20px !important;
    padding: 30px 25px;
    margin-bottom: 100px;
    max-height: 90vh;
    overflow-y: hidden;
    z-index: 10;
    &::-webkit-scrollbar {
      direction: rtl;
      width: 3px;
    }
    .v-input__icon.v-input__icon--prepend-inner {
      margin-left: 5px !important;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: unset;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: grey;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: rgb(66, 66, 66);
    }
    .back-btn {
      position: absolute;
      left: 25px;
      top: 25px;
    }
    .v-input__slot {
      border-radius: 12px !important;
    }
  }
  @media only screen and (max-width: 1000px) {
    .login-card {
      width: 55vw !important;
    }
  }
  @media only screen and (max-width: 800px) {
    .login-card {
      width: 85vw !important;
      left: 55%;
      top: 50%;
    }
  }
  @media only screen and (max-width: 600px) {
    .login-card {
      width: 100% !important;
      left: 53%;
      top: 35%;
      padding: 30px 20px;
    }
  }
  .card-image {
    position: fixed;
    top: 50px;
    right: 53%;
    z-index: 100;
  }
}
</style>
